export enum ChatAdminUserFilter {
  SENDER = 'sender',
  RECEIVER = 'receiver'
}



// WEBPACK FOOTER //
// ./src/app/enums.ts